module.exports = __webpack_public_path__ + "f2c77a6b7e26ff160fdb4193b383b1ea.png";